import { render } from "./StandardLayout.vue?vue&type=template&id=aea7387a"
import script from "./StandardLayout.vue?vue&type=script&lang=js"
export * from "./StandardLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__